import AccessTimeFilledIcon from "@mui/icons-material/AccessTimeFilled";
import DoNotDisturbOnIcon from "@mui/icons-material/DoNotDisturbOn";
import CircleOutlinedIcon from "@mui/icons-material/CircleOutlined";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

// The data is now a map for O(1) lookups.
// The key is the status value, and the value is the status object.
export const statusMap = {
    "0": { value: "0", labelKey: "no_status", type: 'mui', IconComponent: CircleOutlinedIcon, color: "grey" },
    "1": { value: "1", labelKey: "available", type: 'mui', IconComponent: CheckCircleIcon, color: "#27c93f" },
    "2": { value: "2", labelKey: "absent", type: 'mui', IconComponent: AccessTimeFilledIcon, color: "orange" },
    "3": { value: "3", labelKey: "do_not_disturb", type: 'mui', IconComponent: DoNotDisturbOnIcon, color: "#de0030" },
    "4": { value: "4", labelKey: "shivering", type: 'image', iconName: "grelotant" },
    "5": { value: "5", labelKey: "exited", type: 'image', iconName: "excite" },
    "6": { value: "6", labelKey: "tired", type: 'image', iconName: "fatigue" },
    "7": { value: "7", labelKey: "curious", type: 'image', iconName: "curieux" },
    "8": { value: "8", labelKey: "panicked", type: 'image', iconName: "panique" },
    "9": { value: "9", labelKey: "nauseous", type: 'image', iconName: "gastro" },
    "10": { value: "10", labelKey: "stressed", type: 'image', iconName: "stresse" },
    "11": { value: "11", labelKey: "unsteady", type: 'image', iconName: "bougeote" },
    "12": { value: "12", labelKey: "happy", type: 'image', iconName: "joyeux" },
    "13": { value: "13", labelKey: "confused", type: 'image', iconName: "confus" },
    "14": { value: "14", labelKey: "thoughtful", type: 'image', iconName: "pensif" },
    "15": { value: "15", labelKey: "exasperated", type: 'image', iconName: "exaspere" },
    "16": { value: "16", labelKey: "irritated", type: 'image', iconName: "irrite" },
    "17": { value: "17", labelKey: "ill", type: 'image', iconName: "malade" },
    "18": { value: "18", labelKey: "malicious", type: 'image', iconName: "malicieux" },
    "19": { value: "19", labelKey: "joking", type: 'image', iconName: "farceur" },
    "20": { value: "20", labelKey: "annoyed", type: 'image', iconName: "enerver" },
    "21": { value: "21", labelKey: "euphoric", type: 'image', iconName: "euphorique" },
    "22": { value: "22", labelKey: "serene", type: 'image', iconName: "serein" },
    "23": { value: "23", labelKey: "optimistic", type: 'image', iconName: "optimiste" },
    "24": { value: "24", labelKey: "energetic", type: 'image', iconName: "energique" },
    "25": { value: "25", labelKey: "Melancholic", type: 'image', iconName: "Melancolique" },
    "26": { value: "26", labelKey: "grateful", type: 'image', iconName: "reconnaissant" },
    "27": { value: "27", labelKey: "angry", type: 'image', iconName: "enerve" },
    "28": { value: "28", labelKey: "solitary", type: 'image', iconName: "solitaire" },
    "29": { value: "29", labelKey: "calm", type: 'image', iconName: "detendu" },
};

// Export an array of the map's values for easy iteration when rendering the UI.
export const statusList = Object.values(statusMap);